import { render, staticRenderFns } from "./ColaboratorsToolbar.vue?vue&type=template&id=c9764aee&scoped=true&"
import script from "./ColaboratorsToolbar.vue?vue&type=script&lang=js&"
export * from "./ColaboratorsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ColaboratorsToolbar.vue?vue&type=style&index=0&id=c9764aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9764aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VCard,VSelect,VSpacer,VSubheader,VTextField,VToolbar,VToolbarTitle})
